import { render } from "./ClosedAccountingInfo.vue?vue&type=template&id=1223c858"
import script from "./ClosedAccountingInfo.vue?vue&type=script&lang=js"
export * from "./ClosedAccountingInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__